import { useTheme } from '@mui/material/styles';

export const NavStyles = () => {
  const theme = useTheme();

  return {
    border: 'none',
    background: 'transparent',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '& .button__toggle-menu':{
      backgroundColor: theme.palette.primary.main,
      border: "none",
      cursor: "pointer",
      transition: "400ms",
      position: "fixed",
      zIndex: 6,

    },
    '& .button__toggle-menu.open': {
      right: "10px",
      top: "10px",
    },
    '& .button__toggle-menu.open svg': {
      color: 'white',
    },
    '& .button__toggle-menu.open.on-scroll': {
      top: 0,
      height: "40px",
      right: 0,
    },
    '& .button__toggle-menu.open.on-scroll svg': {
      fontSize: "40px !important",
      marginTop: "-1px",
    },
    '& .button__toggle-menu.close': {
      backgroundColor: 'transparent',
      right: "207px",
      top: 0,
    },
    '& .button__toggle-menu.close:hover': {
      opacity: "1 !important",
    },
    '& .MainNav__menu': {
      background: theme.palette.primary.main,
      borderLeft: `4px solid ${theme.palette.primary.light}`,
      height: "100vh",
      padding: "48px 0 20px",
      position: "fixed",
      right: 0,
      top: 0,
      transition: "350ms",
      width: "250px",
      zIndex: 5,
    },
    '& .MainNav__menu.menu--hide': {
      right: "-100%",
    },
    '& .log-btn': {
      display: "block",
      margin: "4px auto",
    },
    '& .MainNav__link': {
      color: "white",
      display: "block",
      padding: "15px 26px",
    },
    '& .MainNav__link.selected': {
    backgroundColor: theme.palette.primary.light,
    },
    '& .MainNav__link:hover': {
      backgroundColor: theme.palette.primary.light,
      color: "white",
      textDecoration: "none",
    },
    '& .MainNav__overlay': {
      background: "rgba(0, 0, 0, 0.5)",
      height: "100%",
      position: "fixed",
      top: 0,
      width: "100%",
      zIndex: 4,
    },
    '& .MuiAccordion-root': {
      background: "transparent",
      boxShadow: "none",
    },
    '& .MuiAccordion-root:before': {
      display: 'none',
    },
    '& .MuiAccordionSummary-root': {
      borderTop: 'none',
      color: '#fff',
      fontWeight: 'bold',
      flexDirection: 'row-reverse',
    },
    '& .MuiAccordionSummary-root:hover': {
      background: theme.palette.primary.dark,
    },
    '& .MuiAccordionSummary-root.Mui-expanded': {
      background: theme.palette.primary.dark
    },
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded': {
      marginLeft: theme.spacing(1),
    },
    '& .menu-wrapper': {
      listStyleType: 'none',
      margin: 0,
      padding: 0,
    },
    '& .MuiCollapse-root .menu-wrapper': {
      background: theme.palette.primary.dark,
    },
    '& .profile-block': {
      display: {
        sm: 'none',
      },
      margin: "14px 0",
      padding: "6px 0",
    },
    '& .profile-block:hover': {
      background: theme.palette.primary.dark,
    },
    '& .UserProfile__name': {
      color: "white",
      fontWeight: 500,
      marginLeft: "12px",
      marginRight: "84px",
    },
    '& .MuiAutocomplete-root': {
      marginTop: '10px',
    },
    '& .MuiAutocomplete-root .Mui-focused': {
      color: 'white',
    },
    '& .MuiAutocomplete-root .Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '1px solid white',
    }
  }
}
